import React from 'react';
import { CTAButton } from './CTAButton';
export function ClosingCTA() {
  return <section id="book" className="relative overflow-hidden border-b border-[#1a1a1a]" data-id="element-140" data-mp="2x5a0ees3ifhd">
      <div className="pointer-events-none absolute left-1/2 top-0 h-72 w-72 -translate-x-1/2 rounded-full bg-emerald-500/10 blur-3xl" aria-hidden="true" data-id="element-141" data-mp="2i8ak82j6heba" />
      <div className="relative mx-auto w-full max-w-3xl px-6 py-24 text-center lg:py-32" data-id="element-142" data-mp="2n9gdq2knx5lv">
        <h2 className="text-3xl font-bold leading-tight tracking-tight text-white sm:text-5xl" data-id="element-143" data-mp="3axq65ncdsrlz">
          See if you&rsquo;re a fit
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-neutral-400" data-id="element-144" data-mp="317etncemta3h">
          Fifteen minutes on where your leads are getting dropped and whether this is worth
          doing. If it&rsquo;s not, we&rsquo;ll say so.
        </p>
        <div className="mt-10 flex justify-center" data-id="element-145" data-mp="3tu9b00g5jtcq">
          <CTAButton data-id="element-146" data-mp="2hocdfi0m8t7">Book a 15-min call</CTAButton>
        </div>
        <p className="mt-6 font-mono text-xs uppercase tracking-[0.15em] text-neutral-600" data-id="element-147" data-mp="2j7ulbn8etxm">
          Phoenix metro &middot; Month to month
        </p>
      </div>
    </section>;
}